import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  CanActivateChildFn,
  UrlTree,
} from '@angular/router';
import { STATES_NAMES } from '@shared/enums/states.enum';

export const stateGuard: CanActivateChildFn = (
  route: ActivatedRouteSnapshot,
): boolean | UrlTree => {
  const router = inject(Router);

  const state = route.pathFromRoot
    .flatMap((r) => Object.entries(r.params))
    .find(([key]) => key === 'state')?.[1];

  if (!state || !isValidStateKey(state)) {
    return navigatToDefaultState(router);
  }

  return true;
};

const navigatToDefaultState = (router: Router): UrlTree => {
  return router.parseUrl('/VA');
};

const isValidStateKey = (
  state: string | null | undefined,
): state is keyof typeof STATES_NAMES => {
  return state !== null && state !== undefined && state in STATES_NAMES;
};
